import Vue from 'vue'

import { Colors, Services } from '@sigma-frontend-libs/commons'
import { EOtpChannelTypes } from '@sigmasms/shared-types'

import { components } from '@/utils'

import info from '@/components/info'
import selectorSendingType from '@/components/selector/sendingType'
import nameField from '@/components/services/otp-settings/commons/form/name'
import { getChannelTypes } from '@/components/services/otp-settings/utils'

const serviceNameViaPoint = Services['otp-settings/channels'].split('/').join('.')
const serviceNameKebab = Services['otp-settings/channels'].split('/').join('-')

function renderNameField(h) {
  return h(
    nameField,
    {
      props: {
        value: this.proxy.name,
        isNew: this.isNew,
        disabled: this.disabled,
        service: serviceNameViaPoint
      },
      on: {
        input: event => {
          this.proxy.name = event
        }
      }
    }
  )
}

function renderChannelTypeField(h) {
  return h(
    selectorSendingType,
    {
      props: {
        value: this.proxy.channelType,
        label: this.getTranslate(`${serviceNameViaPoint}.labels.channelType`),
        items: getChannelTypes(Services['otp-settings/channels']),
        disabled: this.disabled || !this.isNew,
        dense: true,
        rounded: true,
        required: true,
        details: false
      },
      on: {
        input: event => {
          this.proxy.channelType = event
        }
      }
    }
  )
}

function renderInfo(h) {
  return h(
    info,
    {
      props: {
        value: this.getTranslate(`${serviceNameViaPoint}.hints.additionalSettings`),
        color: Colors.info
      }
    }
  )
}
function renderLifetimeField(h) {
  return h(
    components['text-field'],
    {
      props: {
        value: this.proxy.additionalSettings.lifetime,
        label: this.getTranslate(`${serviceNameViaPoint}.labels.additionalSettings.lifetime`),
        disabled: this.disabled,
        dense: true,
        required: true,
        details: false
      },
      on: {
        input: event => {
          this.proxy.additionalSettings.lifetime = event
        }
      }
    }
  )
}
function renderNumberOfTriesField(h) {
  return h(
    components['text-field'],
    {
      props: {
        value: this.proxy.additionalSettings.numberOfTries,
        label: this.getTranslate(`${serviceNameViaPoint}.labels.additionalSettings.numberOfTries`),
        disabled: this.disabled,
        dense: true,
        required: true,
        details: false
      },
      on: {
        input: event => {
          this.proxy.additionalSettings.numberOfTries = event
        }
      }
    }
  )
}
function renderNumberOfRestartField(h) {
  return h(
    components['text-field'],
    {
      props: {
        value: this.proxy.additionalSettings.numberOfRestart,
        label: this.getTranslate(`${serviceNameViaPoint}.labels.additionalSettings.numberOfRestart`),
        disabled: this.disabled,
        dense: true,
        details: false
      },
      on: {
        input: event => {
          /* NOTE:
            В нашем serviceTemplate есть сравнение initialData и data которую нам отдаёт backend
            И так как поле numberOfRestart по типу является не обязательным
            И если оно не указано изначально, то backend не возвращает его
            Поэтому мы должны его добавить в объект additionalSettings реактивно
            чтобы сработал computed dataIsEqual */
          Vue.set(this.proxy.additionalSettings, 'numberOfRestart', event)
        }
      }
    }
  )
}
function renderMTSClientIdField(h) {
  if (this.isSimPush) {
    return h(
      components['text-field'],
      {
        props: {
          value: this.proxy.additionalSettings.mtsClientId,
          label: this.getTranslate(`${serviceNameViaPoint}.labels.additionalSettings.mtsClientId`),
          disabled: this.disabled,

          dense: true,
          required: true,
          details: false
        },
        on: {
          input: event => {
            /* NOTE:
            В нашем serviceTemplate есть сравнение initialData и data которую нам отдаёт backend
            И так как поле mtsClientId по типу является не обязательным
            И если оно не указано изначально, то backend не возвращает его
            Поэтому мы должны его добавить в объект additionalSettings реактивно
            чтобы сработал computed dataIsEqual */
            Vue.set(this.proxy.additionalSettings, 'mtsClientId', event)
          }
        }
      }
    )
  }
}
function renderBooleanField(h, prop) {
  return h(
    components.switch,
    {
      props: {
        value: this.proxy.additionalSettings.code[prop],
        label: this.getTranslate(`${serviceNameViaPoint}.labels.additionalSettings.code.${prop}`),
        disabled: this.disabled
      },
      on: {
        input: event => {
          this.proxy.additionalSettings.code[prop] = event
        }
      }
    }
  )
}
function renderStringField(h, prop, required, number) {
  let mask
  if (number) {
    mask = /^[0-9]*$/
  }

  return h(
    components['text-field'],
    {
      props: {
        value: this.proxy.additionalSettings.code[prop],
        label: this.getTranslate(`${serviceNameViaPoint}.labels.additionalSettings.code.${prop}`),
        disabled: this.disabled,
        dense: true,
        details: false,
        required,
        mask
      },
      on: {
        input: event => {
          this.proxy.additionalSettings.code[prop] = event
        }
      }
    }
  )
}
function renderCodeFields(h) {
  const codeFields = [ 'length' ]

  return codeFields.map(prop => {
    return renderStringField.call(this, h, prop, false, prop === 'length')
  })
}
function renderBooleanFields(h) {
  const booleanFields = [ 'beautify' ]

  return h(
    'div',
    {
      class: 'grid grid-gap--8'
    },
    [
      booleanFields.map(prop => {
        return renderBooleanField.call(this, h, prop)
      })
    ]
  )
}
function renderAdditionalSettingsCode(h) {
  if (this.proxy.channelType === EOtpChannelTypes.sms) {
    return h(
      components.card,
      {
        class: `${serviceNameKebab}-form__code`,
        props: {
          title: this.getTranslate(`${serviceNameViaPoint}.titles.additionalSettings.code`),
          dashed: true,
          outline: true,
          rounded: true
        }
      },
      [
        renderCodeFields.call(this, h),
        renderBooleanFields.call(this, h)
      ]
    )
  }
}
function renderAdditionalSettings(h) {
  return h(
    components.card,
    {
      class: `${serviceNameKebab}-form__additional`,
      props: {
        title: this.getTranslate(`${serviceNameViaPoint}.titles.additionalSettings.title`),
        outline: true,
        dashed: true,
        rounded: true
      }
    },
    [
      renderInfo.call(this, h),
      renderLifetimeField.call(this, h),
      renderNumberOfTriesField.call(this, h),
      renderNumberOfRestartField.call(this, h),
      renderMTSClientIdField.call(this, h),
      renderAdditionalSettingsCode.call(this, h)
    ]
  )
}

export default function(h) {
  return h(
    components.form,
    {
      class: {
        [`${serviceNameKebab}-form`]: true,
        [`${serviceNameKebab}-form--new`]: this.isNew
      }
    },
    [
      renderNameField.call(this, h),
      renderChannelTypeField.call(this, h),
      renderAdditionalSettings.call(this, h)
    ]
  )
}
